import type { ApplyV2TempCourse } from '@core/app/types/applyV2Type'
import ApplyV2DataRow from '@core/components/ApplyDialogV2/ApplyV2DataRow'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import FileUploaderV2List from '@core/components/ApplyDialogV2/FileUploaderV2List'
import decodeHtmlEntitiesRecursive from '@core/utils/helpers/decodeHtmlEntitiesRecursive'
import useFormattedDatesPeriod from '@core/utils/hooks/useFormattedDatesPeriod'
import dayjs from 'dayjs'
import React from 'react'
import './ApplyV2ReviewApplyCourse.scss'
import duration from 'dayjs/plugin/duration'
import { useTranslation } from 'react-i18next'
dayjs.extend(duration)

const baseClass = 'ApplyV2ReviewApplyCourse'

interface Props {
    className?: string
    isShowExpandButton?: boolean
}

function ApplyV2ReviewApplyCourse({ className = '' }: Props) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
    } = useApplyV2Context()
    const data = postProfileData?.data?.course || []
    return (
        <div className={`${baseClass} ${className}`}>
            {data.map((course) => (
                <ApplyV2ReviewApplyCourseItem key={course.uid || course.existingId} {...course} />
            ))}
        </div>
    )
}

function ApplyV2ReviewApplyCourseItem({
    uid,
    existingId,
    courseName,
    courseDescription,
    startDate,
    endDate,
    courseListId,
    verified,
    files,
}: ApplyV2TempCourse) {
    const { formatDateRange, formatDuration } = useFormattedDatesPeriod()
    const { t } = useTranslation()
    function formatPeriod(fromDate?: string | null, toDate?: string | null): string {
        if (!fromDate && !toDate) return ''

        const from = fromDate ? dayjs(fromDate) : null
        const to = toDate ? dayjs(toDate) : dayjs()

        const range = [from ? from.format('MMM YYYY') : '', toDate ? to.format('MMM YYYY') : 'Present']
            .filter(Boolean)
            .join(' – ')

        if (!from) return range

        const years = to.diff(from, 'year')
        const months = to.diff(from.add(years, 'year'), 'month')

        const parts = []
        if (years > 0) parts.push(t('10223', { count: years }))
        if (months > 0) parts.push(t('10226', { count: months }))

        const durationStr = parts.length ? ` (${parts.join(' ')})` : ''

        return range + durationStr
    }

    return (
        <div className={`${baseClass}__item`}>
            <div className={`${baseClass}__item--name`}>{decodeHtmlEntitiesRecursive(courseName)}</div>
            {(startDate || endDate) && (
                <ApplyV2DataRow fieldType={'date'} className={`${baseClass}__item--date`}>
                    <div className={`${baseClass}__items--course-period`}>
                        <span>
                            {formatDateRange(startDate, endDate, {
                                dateFormat: 'MMM YYYY',
                            })}
                        </span>
                        <span className={`${baseClass}__items--course-period-total`}>
                            {!!formatDuration(startDate, endDate, {
                                showMonths: true,
                            }) &&
                                ` (${formatDuration(startDate, endDate, {
                                    showMonths: true,
                                })})`}
                        </span>
                    </div>
                </ApplyV2DataRow>
            )}
            {/*{location && (*/}
            {/*    <ApplyV2DataRow fieldType={'location'} className={`${baseClass}__item--email`}>*/}
            {/*        {location}*/}
            {/*    </ApplyV2DataRow>*/}
            {/*)}*/}
            {courseDescription && (
                <div className={`${baseClass}__item--description`}>
                    {decodeHtmlEntitiesRecursive(courseDescription)}
                </div>
            )}
            <FileUploaderV2List files={files || []} isShowDelete={false} isShowParseInfo={false}></FileUploaderV2List>
        </div>
    )
}

export default ApplyV2ReviewApplyCourse
